import { render, staticRenderFns } from "./ForgotMyPasswordView.vue?vue&type=template&id=2d1030be&"
import script from "./ForgotMyPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ForgotMyPasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports